import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { FloatInput } from "src/componentes";
import { NFeCadastroItensModalConsulta } from "./Modal/NFe.Cadastro.Item.Consulta";
import { NFeCadastroItemCode } from "./NFe.Cadastro.Item.Code";
import { NFeCadastroItemModalPropriedadesView } from "./Modal/NFe.Cadastro.Item.Modal.Propriedades.View";
import ProdutoCadastroView from "src/pages/Privada/Estoque/Produto/Cadastro/ProdutoCadastro.View";

const NFeCadastroItemView = () => {
  const code = NFeCadastroItemCode();

  if (code.cadastro) {
    return (
      <Row>
        <ProdutoCadastroView
          onSuccess={code.handleSuccessCadastro}
          onCancel={code.handleCancelCadastro}
          initialValue={code.getInitialValueCadastro()}
        />
      </Row>
    );
  }

  return (
    <div className="mb-5">
      {!code.loading ? (
        <>
          <Form
            noValidate
            onSubmit={code.formProdutoConsulta.handleSubmit(
              code.onSubmitProdutoConsulta
            )}
          >
            <Row>
              <Col xs={12}>
                <FloatInput
                  label="Consulta"
                  autoFocus={true}
                  errorsMessage={code.formProdutoConsulta.formState.errors.nome}
                  registerField={code.formProdutoConsulta.register("nome")}
                  textAlign="center"
                />
              </Col>
              <Col>
                <Button
                  variant="link"
                  type="button"
                  onClick={() => code.setCadastro(true)}
                >
                  Novo
                </Button>
              </Col>
            </Row>
          </Form>
          {code.descricaoProdutoConsulta && (
            <Row>
              <Col xs={12} className="text-center">
                <h1>{code.descricaoProdutoConsulta}</h1>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={12}>
              {code.nfeItensLoad.dataProdutoNFe &&
                code.nfeItensLoad.dataProdutoNFe.length > 0 && (
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th className="col-xs-10 col-md-8">Nome</th>
                        <th className="col-02">Qtd</th>
                        <th className="col-2 text-end">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {code.nfeItensLoad.dataProdutoNFe?.map((item, index) => (
                        <tr
                          key={index}
                          onClick={code.handleClickPropriedades(item, index)}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="col-xs-12 col-md-8">
                            {item.nome} {"[" + item.codigoProduto + "]"}
                          </td>
                          <td className="col-02">
                            {item.quantidadeComercial
                              ?.toString()
                              .replace(".", ",")}
                          </td>
                          <td className="col-2 text-end">
                            {(
                              item.valorUnitarioComercial *
                              item.quantidadeComercial
                            )
                              .toFixed(2)
                              .replace(".", ",")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
            </Col>
          </Row>
          <NFeCadastroItensModalConsulta
            show={code.modalShowConsultaProduto}
            onHide={code.onHideModalConsultaProduto}
            onSelect={code.onSelectModalConsultaProduto}
            data={code.dataProdutoConsulta}
          />
          <NFeCadastroItemModalPropriedadesView
            show={code.modalShowPropriedades}
            produto={code.produtoPropriedades}
            onCancel={code.onCancelModalPropriedades}
            onDelete={code.onDeleteModalPropriedades}
            onConfirm={code.onConfirmModalPropriedades}
          />
          <div className="fixed-bottom">
            <Container className="py-3">
              <Row>
                <Col xs={!code.possuiItens() ? 12 : 6} className="d-grid">
                  <Button
                    variant="outline-secondary"
                    onClick={code.handleVoltar()}
                  >
                    Voltar
                  </Button>
                </Col>
                {code.possuiItens() && (
                  <Col xs={6} className="d-grid">
                    <Button
                      variant="outline-primary"
                      onClick={code.handleProximo}
                    >
                      Próximo {code.totalNFe().toFixed(2).replace(".", ",")}
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </div>
  );
};

export default NFeCadastroItemView;
